import { AllocatedPlaceInput } from '../../lib/types/models/trip-booking/trip-date-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getRecommendedAllocations(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripDates.getRecommendedAllocations.url, { id }))
    .get<AllocatedPlaceInput[]>()
}
